export default __webpack_public_path__ + "static/media/r3dent_small.5c155712.svg";